// export const BASE_URL = window.location.hostname === 'localhost' ? 'http://caffecinema.local' : window.location.origin;
export const BASE_URL = window.location.origin;
export const SITE_HOST = window.location.host;